// extracted by mini-css-extract-plugin
module.exports = {"contactInformation":"styles_contactInformation__37rQB","imageWrapper":"styles_imageWrapper__3fARo","image":"styles_image__1JAFq"};